import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

// Pages
import Dashboard from '@components/Dashboard/Dashboard';
import Associations from '@components/Associations/Associations';
import AssociationView from '@components/Associations/AssociationView/AssociationView';
import UnitView from '@components/Associations/UnitView/UnitView';
import UploadUnits from '@components/Associations/UploadUnits/UploadUnits';

import ManagementCompanies from '@components/ManagementCompanies/ManagementCompanies';
import ManagementCompanyView from '@components/ManagementCompanies/ManagementCompanyView/ManagementCompanyView';

import EscrowCompanies from '@components/EscrowCompanies/EscrowCompanies';
import EscrowCompanyView from '@components/EscrowCompanies/EscrowCompanyView/EscrowCompanyView';

import Lenders from '@components/Lenders/Lenders';
import LenderView from '@components/Lenders/LenderView/LenderView';

import Developers from '@components/Developers/Developers';
import DeveloperView from '@components/Developers/DeveloperView/DeveloperView';

import PolicyCarriers from '@components/PolicyCarriers/PolicyCarriers';
import PolicyCarrierView from '@components/PolicyCarriers/PolicyCarrierView/PolicyCarrierView';

import EvidenceOfInsurance from '@components/EvidenceOfInsurance/EvidenceOfInsurance';
import EvidenceOfInsuranceEdit from '@components/EvidenceOfInsurance/EvidenceOfInsuranceEdit/EvidenceOfInsuranceEdit';
import EvidenceOfInsutanceStatistics from '@components/EvidenceOfInsurance/EvidenceOfInsuranceStatistics/EvidenceOfInsuranceStatistics';

import Announcements from '@components/Announcements/Announcements';

import Settings from '@components/Settings/Settings';
import AdminUsers from '@components/AdminUsers/AdminUsers';
import MyAccount from '@components/MyAccount/MyAccount';

import Login from '@components/Login/Login';
import ForgotPassword from '@components/Login/ForgotPassword/ForgotPassword';
import ResetPassword from '@components/Login/ResetPassword/ResetPassword';

// Layouts
import Default from '@components/Layout/Default';
import Auth from '@components/Layout/Auth';
import isAllowed from '@src/auth';

export const Router = props => (
  <Switch>
    <Route
      path={'/'}
      exact
      render={() => {
        if (props.isLogged) {
          return (
            <Default {...props} activeMenu={'dashboard'}>
              <Dashboard {...props} />
            </Default>
          );
        } else {
          return (
            <Auth {...props}>
              <Login {...props} />
            </Auth>
          );
        }
      }}
    />

    <Route
      path={'/associations'}
      exact
      render={() => {
        return (
          <Default {...props} activeMenu={'associations'}>
            <Associations {...props} />
          </Default>
        );
      }}
    />

    <Route
      path={'/announcements'}
      exact
      render={() => {
        return (
          <Default {...props} activeMenu={'announcements'}>
            <Announcements {...props} />
          </Default>
        );
      }}
    />

    <Route
      path={'/associations/:id'}
      exact
      render={routeOption => (
        <Default {...props} activeMenu={'associations'}>
          <AssociationView {...routeOption.match.params} {...props} />
        </Default>
      )}
    />
    <Route
      path={'/associations/upload-units/:id'}
      exact
      render={routeOption => (
        <Default {...props} activeMenu={'associations'}>
          <UploadUnits {...routeOption.match.params} {...props} />
        </Default>
      )}
    />
    <Route
      path={'/units/:id'}
      exact
      render={routeOption => (
        <Default {...props} activeMenu={'associations'}>
          <UnitView {...routeOption.match.params} {...props} />
        </Default>
      )}
    />

    {/* Management Companies */}
    <Route
      path={'/management-companies'}
      exact
      render={() => {
        return (
          <Default {...props} activeMenu={'companies'}>
            <ManagementCompanies {...props} />
          </Default>
        );
      }}
    />
    <Route
      path={'/management-companies/:id'}
      exact
      render={routeOption => (
        <Default {...props} activeMenu={'companies'}>
          <ManagementCompanyView {...routeOption.match.params} {...props} />
        </Default>
      )}
    />

    {/* Escrow Companies */}
    <Route
      path={'/escrow-companies'}
      exact
      render={() => {
        return (
          <Default {...props} activeMenu={'companies'}>
            <EscrowCompanies {...props} />
          </Default>
        );
      }}
    />
    <Route
      path={'/escrow-companies/:id'}
      exact
      render={routeOption => (
        <Default {...props} activeMenu={'companies'}>
          <EscrowCompanyView {...routeOption.match.params} {...props} />
        </Default>
      )}
    />

    {/* Developers */}
    <Route
      path={'/developers'}
      exact
      render={() => {
        return (
          <Default {...props} activeMenu={'companies'}>
            <Developers {...props} />
          </Default>
        );
      }}
    />
    <Route
      path={'/developers/:id'}
      exact
      render={routeOption => (
        <Default {...props} activeMenu={'companies'}>
          <DeveloperView {...routeOption.match.params} {...props} />
        </Default>
      )}
    />

    {/* Lenders */}
    <Route
      path={'/lenders'}
      exact
      render={() => {
        return (
          <Default {...props} activeMenu={'companies'}>
            <Lenders {...props} />
          </Default>
        );
      }}
    />
    <Route
      path={'/lenders/:id'}
      exact
      render={routeOption => (
        <Default {...props} activeMenu={'companies'}>
          <LenderView {...routeOption.match.params} {...props} />
        </Default>
      )}
    />

    {/* Carriers */}
    <Route
      path={'/carriers'}
      exact
      render={() => {
        return (
          <Default {...props} activeMenu={'companies'}>
            <PolicyCarriers {...props} />
          </Default>
        );
      }}
    />
    <Route
      path={'/carriers/:id'}
      exact
      render={routeOption => (
        <Default {...props} activeMenu={'companies'}>
          <PolicyCarrierView {...routeOption.match.params} {...props} />
        </Default>
      )}
    />

    {/* Settings */}
    <Route
      path={'/settings/details'}
      exact
      render={() => {
        const allowed = isAllowed({ action: 'Settings::tenant' });
        return (
          <Default {...props} activeMenu={'settings'}>
            {allowed ? <Settings {...props} /> : <Redirect to={'/'} />}
          </Default>
        );
      }}
    />
    <Route
      path={'/settings/users'}
      exact
      render={() => {
        const allowed = isAllowed({ action: 'Settings::users' });
        return (
          <Default {...props} activeMenu={'settings'}>
            {allowed ? <AdminUsers {...props} /> : <Redirect to={'/'} />}
          </Default>
        );
      }}
    />
    {/* My Account */}
    <Route
      path={'/my-account'}
      exact
      render={() => {
        return (
          <Default {...props} activeMenu={'account'}>
            <MyAccount {...props} />
          </Default>
        );
      }}
    />

    {/* EOIs */}
    <Route
      path={'/eois'}
      exact
      render={() => {
        return (
          <Default {...props} activeMenu={'eois'}>
            <EvidenceOfInsurance {...props} />
          </Default>
        );
      }}
    />
    <Route
      path={'/eois/:id'}
      exact
      render={routeOption => (
        <Default {...props} activeMenu={'eois'}>
          <EvidenceOfInsuranceEdit {...routeOption.match.params} {...props} />
        </Default>
      )}
    />
    <Route
      path={'/eoi-statistics'}
      exact
      render={() => {
        return (
          <Default {...props} activeMenu={'eois'}>
            <EvidenceOfInsutanceStatistics {...props} />
          </Default>
        );
      }}
    />

    <Route
      path={'/forgot-password'}
      exact
      render={() => {
        return (
          <Auth {...props}>
            <ForgotPassword {...props} />
          </Auth>
        );
      }}
    />

    <Route
      path={'/reset-password/:hash'}
      exact
      render={props2 => (
        <Auth {...props}>
          <ResetPassword {...props2.match.params} {...props} />
        </Auth>
      )}
    />

    <Route
      path={'/qb-token-redirect'}
      exact
      render={() => {
        const redirectPath = localStorage.getItem('qbRedirect');
        localStorage.removeItem('qbRedirect');
        return (
          <React.Fragment>
            <Redirect to={redirectPath} />
          </React.Fragment>
        );
      }}
    />

    <Route
      path={'/logout'}
      exact
      render={() => {
        props.onLogout();
        return (
          <Default {...props}>
            {props.isAdmin ? <Redirect to="/admin" /> : <Redirect to="/" />}
          </Default>
        );
      }}
    />

    <Redirect to={'/'} />
  </Switch>
);
